import ListEmptyView from "./ListEmptyView";

/**
 * List Empty Container
 *
 * Provides the empty state component for roster lists when no players match
 * the current filter criteria. Separated as a Container/View pair to allow
 * future data fetching for dynamic empty state messaging.
 * @module features/roster-management/components/ListEmpty/ListEmptyContainer
 */
const ListEmptyContainer = () => {
  return <ListEmptyView />;
};

export default ListEmptyContainer;
